export type Option = {
  label: string;
  value: string;
};
export const labelSets: Record<string, Option[]> = {
  Kessel: [
    { label: 'Vorlauf', value: 'Vorlauf' },
    { label: 'Rücklauf', value: 'Rücklauf' },
    { label: 'Abgastemperatur', value: 'Abgastemperatur' },
  ],
  Warmwasseraufbereitung: [
    { label: 'Warmwasser', value: 'Warmwasser' },
    { label: 'Zirkulation', value: 'Zirkulation' },
  ],
  Heizkreis: [
    { label: 'Vorlauf', value: 'Vorlauf' },
    { label: 'Rücklauf', value: 'Rücklauf' },
  ],
  'Fernwärme Primärseite': [
    { label: 'Vorlauf', value: 'Vorlauf' },
    { label: 'Rücklauf', value: 'Rücklauf' },
  ],
  Pufferspeicher: [
    { label: 'Primäre Einlasstemperatur', value: 'Primäre Einlasstemperatur' },
    { label: 'Primäre Auslasstemperatur', value: 'Primäre Auslasstemperatur' },
    { label: 'Mitte', value: 'Mitte' },
    { label: 'Oben', value: 'Oben' },
  ],
  Mischer: [
    { label: 'Sekundäre Einlasstemperatur', value: 'Sekundäre Einlasstemperatur' },
    { label: 'Sekundäre Auslasstemperatur', value: 'Sekundäre Auslasstemperatur' },
  ],
  'Solarthermieanlage Primärseite': [
    { label: 'Vorlauf', value: 'Vorlauf' },
    { label: 'Rücklauf', value: 'Rücklauf' },
  ],
  BHKW: [
    { label: 'Vorlauf', value: 'Vorlauf' },
    { label: 'Rücklauf', value: 'Rücklauf' },
  ],
  'Wärmepumpe Primäre': [
    { label: 'Vorlauftemperatur', value: 'Vorlauftemperatur' },
    { label: 'Rücklauftemperatur', value: 'Rücklauftemperatur' },
  ],
  'Wärmepumpe Sekundäre': [
    { label: 'Vorlauftemperatur', value: 'Vorlauftemperatur' },
    { label: 'Rücklauftemperatur', value: 'Rücklauftemperatur' },
  ],
  'Wärmetauscher Primäre': [
    { label: 'Vorlauftemperatur', value: 'Vorlauftemperatur' },
    { label: 'Rücklauftemperatur', value: 'Rücklauftemperatur' },
  ],
  'Wärmetauscher Sekundäre': [
    { label: 'Vorlauftemperatur', value: 'Vorlauftemperatur' },
    { label: 'Rücklauftemperatur', value: 'Rücklauftemperatur' },
  ],
};

export const shortLabelSets: Record<string, string> = {
  'Kessel Vorlauf': 'VL',
  'Kessel Rücklauf': 'RL',
  'Kessel Abgastemperatur': 'AGT',
  'Warmwasseraufbereitung Warmwasser': 'TWW',
  'Warmwasseraufbereitung Zirkulation': 'TWZ',
  'Heizkreis Vorlauf': 'VL',
  'Heizkreis Rücklauf': 'RL',
  'Fernwärme Primärseite Vorlauf': 'VL',
  'Fernwärme Primärseite Rücklauf': 'RL',
  'Pufferspeicher Primäre Einlasstemperatur': 'VL',
  'Pufferspeicher Primäre Auslasstemperatur': 'RL',
  'Pufferspeicher Mitte': 'M',
  'Pufferspeicher Oben': 'O',
  'Mischer Sekundäre Einlasstemperatur': 'VL',
  'Mischer Sekundäre Auslasstemperatur': 'RL',
  'Solarthermieanlage Primärseite Vorlauf': 'VL',
  'Solarthermieanlage Primärseite Rücklauf': 'RL',
  'BHKW Vorlauf': 'VL',
  'BHKW Rücklauf': 'RL',
  'Wärmepumpe Primäre Vorlauftemperatur': 'VL',
  'Wärmepumpe Primäre Rücklauftemperatur': 'RL',
  'Wärmepumpe Sekundäre Vorlauftemperatur': 'VL',
  'Wärmepumpe Sekundäre Rücklauftemperatur': 'RL',
  'Wärmetauscher Primäre Vorlauftemperatur': 'VL',
  'Wärmetauscher Primäre Rücklauftemperatur': 'RL',
  'Wärmetauscher Sekundäre Vorlauftemperatur': 'VL',
  'Wärmetauscher Sekundäre Rücklauftemperatur': 'RL',
};

export function getPufferspeicherPairLabelMap(componentNumber?: string): Record<string, string> {
  const prefix = `Pufferspeicher${componentNumber ? ' ' + componentNumber.trim() : ''} `;
  return {
    [`${prefix}Primäre Einlasstemperatur`]: `${prefix}Primäre Auslasstemperatur`,
    [`${prefix}Primäre Auslasstemperatur`]: `${prefix}Primäre Einlasstemperatur`,
    [`${prefix}Mitte`]: `${prefix}Oben`,
    [`${prefix}Oben`]: `${prefix}Mitte`,
  };
}
